export default {
  layoutSelectors: ["#shipping-phone"],
  inputIdentifier: "#shipping-phone",
  countryIdentifier: "#components-form-token-input-0",
  label: "block shipping checkout (phone)"
}
